/*
|--------------------------------------------------------------------------
| Analytics: Parse.ly
|--------------------------------------------------------------------------
*/

/**
 * @namespace
 */
__gh__webApp.analytics.parsely = {

	/**
	 * Track Parse.ly
	 * @param {object} options
	 * @param {string} options.path - path portion of url (ie "/url-path")
	 * @param {string} [options.title=null] - title
	 */
	"preload": {
		trackPageEventQueue: [],
		trackPlayEventQueue: [],
		trackPauseEventQueue: [],
		loaded: false
	},
	
	
	"init":function(){
		var parsely = this;
	    PARSELY = {
	        autotrack: false,
	        onload: function() {
		        
		        parsely.preload.loaded = true;
		        
		        for (var i = 0; i < parsely.preload.trackPageEventQueue.length; i++) {
		            PARSELY.beacon.trackPageView(parsely.preload.trackPageEventQueue[i]);
		        }
		        
		        for (var i = 0; i < parsely.preload.trackPlayEventQueue.length; i++) {
			        var trackPlayEvent = parsely.preload.trackPlayEventQueue[i];
		            PARSELY.video.trackPlay(trackPlayEvent.videoId,trackPlayEvent.metaData);
		        }
		        
		        for (var i = 0; i < parsely.preload.trackPauseEventQueue.length; i++) {
		            PARSELY.video.trackPause(parsely.preload.trackPauseEventQueue[i]);
		        }
	        }
	    };
	},
	
	
	"track":function(options){
		var url 		= (options.url) ? options.url : document.location.href,
			urlref 		= (options.urlref) ? options.urlref : document.referrer;
			parsely 	= this;

	    var event = {
	        url			: url,
	        urlref		: urlref,
	        js			: 1,
	        action_name	: "Next Post"
	    };
	    
	    if(parsely.preload.loaded){
	        PARSELY.beacon.trackPageView(event);
	    }else{
	        parsely.preload.trackPageEventQueue.push(event);
	    }
	},
	
	
	/**
	 * Track a video play event
	 * @param {object} options
	 * @param {string} options.videoID - requried id for video
	 * @param {string} options.imageURL - recommended URL pointing to a full-sized (i.e. not thumbnail) image representing the video
	 * @param {string} options.title - required title of the video
	 * @param {string} options.section - recommended the section a video belongs to
	 * @param {integer} options.pubDateTimestamp - recommended the date the video was published specified in milliseconds since the Unix epoch
	 * @param {array} options.tags - optional a list of arbitrary tags that provide more context for reporting
	 * @param {array} options.authors - optional the author(s) of the video (an author need not correspond to a person but can be an entity like a studio)
	 */
	"trackPlay":function(options){
		if (!this.videoTrackingIsEnabled()) {return;}
		
		var commonJS			= __gh__webApp.common,
			videoID				= ("videoID" in options) ? options.videoID : null,
			imageURL 			= ("imageURL" in options) ? options.imageURL : null,
			title 				= ("title" in options) ? options.title : null,
			section 			= ("section" in options) ? options.section : null,
			pubDateTimestamp	= ("pubDateTimestamp" in options) ? options.pubDateTimestamp : null,
			tags				= ("tags" in options) ? options.tags : null,
			authors				= ("authors" in options) ? options.authors : null,
			parsely 			= this;

	    var event = {
	        "videoID"		: videoID,
	        "title"			: title,
	        "image_url"		: imageURL,
	        "section"		: section,
	        "pub_date_tmsp"	: pubDateTimestamp,
	        "tags"			: tags,
	        "authors"		: authors
	    };
	   
		//Remove null values
		event = commonJS.cleanObject(event);
		
		if(parsely.preload.loaded){
		    PARSELY.video.trackPlay(event.videoID,event.metaData);
		}else{
		    parsely.preload.trackPlayEventQueue.push(event);
		}

	},
	
	
	/**
	 * Track a video play event
	 * @param {string} videoID - 
	 */
	"trackPause":function(videoID){
		if (!this.videoTrackingIsEnabled()) {return;}
		
		var parsely = this;
	    
	    if(parsely.preload.loaded){
	        PARSELY.video.trackPause(videoID);
	    }else{
	        parsely.preload.trackPauseEventQueue.push(videoID);
	    }
	},
	
	
	/**
	 * Test to see if video tracking is enabled for the site
	 */
	"videoTrackingIsEnabled": function(){
		var commonJS = __gh__webApp.common;
		return commonJS.getObjectProperty(__gh__coreData["3rdPartyData"],"analytics.parsely.videoTrackingEnabled");
	}
};
